import { render, staticRenderFns } from "./home.vue?vue&type=template&id=521996bd&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=521996bd&prod&lang=sass&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=521996bd&prod&lang=sass&"
import style2 from "./home.vue?vue&type=style&index=2&id=521996bd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521996bd",
  null
  
)

export default component.exports